<template>
  <path
    d="M10 16.0002H14C14.55 16.0002 15 15.5502 15 15.0002V10.0002H16.59C17.48 10.0002 17.93 8.92021 17.3 8.29021L12.71 3.70021C12.32 3.31021 11.69 3.31021 11.3 3.70021L6.71 8.29021C6.08 8.92021 6.52 10.0002 7.41 10.0002H9V15.0002C9 15.5502 9.45 16.0002 10 16.0002ZM6 18.0002H18C18.55 18.0002 19 18.4502 19 19.0002C19 19.5502 18.55 20.0002 18 20.0002H6C5.45 20.0002 5 19.5502 5 19.0002C5 18.4502 5.45 18.0002 6 18.0002Z"
  />
</template>
